





















































































































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import BaseContainer from '@/components/BaseContainer.vue';
import StatusPanel from '@/components/StatusPanel.vue';
import BaseInfoPanel from '@/components/BaseInfoPanel.vue';
import { Inquiry, yun } from '@/http';
import ButtonPanel from '@/components/ButtonPanel.vue';
import orderDetailcc from './orderDetailcc.vue';
import { default as PageDescribe } from '@/components/PageDescribe.vue';
import { formRules } from '@/common/util/validator';
import { upload } from '../../common/util/ossUploadService';

import ImagesUploadorder from '@/components/ImagesUploadorder.vue';
import { enums } from '@/common/enums';

import { default as DataPanel } from '@/components/DataPanel.vue';
import publicFunc from '../../common/util/publicFunc';
@Component({
    components: {
        BaseContainer,
        StatusPanel,
        BaseInfoPanel,
        ButtonPanel,
        ImagesUploadorder,
        orderDetailcc,
        PageDescribe,
        DataPanel,
    },
})
export default class InquiryDetail extends Vue {
    public winVisible = false;
    public formDataWin: any = {};
    public loading: boolean = false;
    public adjustCarrierVisible = false;
    public requoteVisible = false;
    public title: string = '订单状态为待接单，支持用户在线编辑订单，支持重新、终结、删除订单';
    public cspdiaConfig: any = {
        cspDialogVisible: false,
        title: '询价单终结',
        content: '确认终结询价单？',
    };
    public publicFunc: any = publicFunc;
    public formRules = formRules;
    public id: any = '';
    public name: any = '';
    public detailData: any = {};
    public goodsList: any = [];
    public goodsUnitType = enums.goodsUnitTypeNum;
    public freightUnitType = enums.freightUnitType;
    public pricingModeType = enums.pricingModeType;

    public formData: any = {
        carrierId: '',
        carrierName: '',
        priceSource: '',
        pricingMode: '',
        freightPrice: '',
        freightUnit: '',
        goodsList: [
            {
                orderId: '',
                goodsName: '',
                quantity: '',
                unit: '',
                planQuantity: '',
                planGoodsUnit: '',
                model: '',
                remark: '',
            },
        ],
    };
    public detials: any = '';
    public async created() {
        this.id = this.$route.query.id;
        this.name = this.$route.query.name;
        this.getdd();
    }
    public carLengthList: any = [];
    public vehicleTypeList: any = [];
    public sscar: any = '';
    public sssing: any = '';
    public async getdd() {
        this.carLengthList = await yun.GetDicList({ typeName: 'carLength' });
        this.vehicleTypeList = await yun.GetDicList({ typeName: 'vehicleType' });
        let dd = await yun.OrdergetDetaill(this.id);
        dd.goodsList.map((data) => {
            data.planQuantity = data.quantity;
            data.planGoodsUnit = data.unit;
        });
        let skip = 1;
        dd.goodsList.map((data) => {
            orderId: this.$route.query.id;
            data.index = skip;
            skip = skip + 1;
            data.planQuantity = data.quantity;
            data.planGoodsUnit = data.unit;
        });
        this.detials = dd;
        this.formData.goodsList = dd.goodsList;
        this.sssing = '';
        let resd = await yun.GetFreight({
            carLength: this.detials.carLength,
            inquiryCode: this.detials.inquiryCode,
        });
        console.log(resd);
        this.formData.carriageWay = resd.carriageWay ? resd.carriageWay : this.formData.carriageWay;
        if (resd.carrierId) {
            this.carrierId1 = resd.carrierId;
            this.carrierName1 = resd.carrierName;
            this.hascarrier = true;
        }

        this.CarriageWay1 = resd.carriageWay;
        this.cars = [];
        if (resd.cars) {
            this.cars = resd.cars;
            if (this.cars.length) {
                this.formData.priceSource = 1;
                this.formData.pricingMode = 1;
                this.formData.carrierId = this.carrierId1;
                this.formData.carrierName = this.carrierName1;
                if (resd.cars.length == 1) {
                    this.sscar(0, resd.cars[0]);
                }
            }
        }
    }
    public cars: any = [];
    public hascarrier: any = false;
    rowStyle({ row, rowIndex }) {
        Object.defineProperty(row, 'rowIndex', {
            //给每一行添加不可枚举属性rowIndex来标识当前行
            value: rowIndex,
            writable: true,
            enumerable: false,
        });
    }
    back() {
        this.$router.back();
    }
    public tableData: any = [];
    public shipperAttachmentList: any = [];
    /**删除询价单 */
    public dialogConfig: any = {
        title: '终结该运单',
        show: false,
    };
    confirmClose() {
        this.dialogConfig = {
            title: '',
            show: false,
        };
    }
    async confirmOk() {
        this.dialogConfig = {
            show: false,
        };
        if (this.btt == 4) {
            this.formData.goodsList[0].orderId = this.$route.query.id;
            this.formData.goodsList = [this.formData.goodsList[0]];
            let res = await yun.CarrierOrder(this.formData);
            this.$message.success('发布成功!');
            this.$router.back();
        }
    }
    public btt: any = 0;
    public ssid: any = '';
    public carrierId1 = '';
    public carrierName1 = '';
    public CarriageWay1: any = '';
    carss(index, resd) {
        this.sscar = index;
        this.formData.freightPrice = resd.price ? resd.price : this.formData.price;
        this.formData.freightUnit = 1;
    }
    public freightSourceChange() {
        this.formData.carrierId = '';
        this.formData.carrierName = '';
        this.formData.freightUnit = '';
        this.formData.freightPrice = '';
        this.formData.pricingMode = '';
        this.sssing = '';
        this.sscar = '';
        this.carrierChange();
        if (this.formData.priceSource == 1) {
            this.formData.carrierId = this.carrierId1;
            this.formData.carrierName = this.carrierName1;
            this.formData.pricingMode = 1;
        }
    }
    ordergo() {
        console.log('formdata', this.formData);
        this.$refs.formData.validate(async (valid) => {
            if (valid) {
                this.ssid = '';
                this.btt = 4;
                this.dialogConfig = {
                    title: '发布运单',
                    show: true,
                };
                // this.$confirm('确认发布运单?', '确认发布', {
                //     confirmButtonText: '确定',
                //     cancelButtonText: '取消',
                //     type: 'warning',
                // })
                //     .then(async () => {
                //         this.formData.goodsList[0].orderId = this.$route.query.id
                //             let res = await yun.CarrierOrder(this.formData)
                //             this.$message.success('发布成功!');
                //             this.$router.back()
                //         }
                //     )
            }
        });
    }
    public $refs: {
        formData: HTMLFormElement;
        formData1: HTMLFormElement;
        formData2: HTMLFormElement;
    };
    /**装车要素 */
    public activeName: any = 'first';
    setImage(name, url, uid) {
        console.log('url=====>' + url);
        this.shipperAttachmentList.push({
            name: name,
            url: url,
            id: '',
        });
        this.formData.carrierAttList = this.shipperAttachmentList;
        // console.log('add-attachementUrls======>', this.shipperAttachmentList);
    }
    deleteImage(name, uid, url) {
        this.shipperAttachmentList = this.shipperAttachmentList.filter((v) => {
            return v.url !== url;
        });
        // console.log('del-attachementUrls', this.shipperAttachmentList, this.shipperAttachmentList.length);
    }
    carrierNameEnd() {
        if (this.formData.carrierId) {
        } else {
            this.formData.carrierName = '';
        }
    }
    public carCodeEnd() {
        console.log('cc2');
        if (!this.formData.carrierId) {
            this.formData.carrierName = '';
            this.formData.freightUnit = '';
            this.formData.freightPrice = '';
        }
    }
    public carCodechange(val) {
        this.formData.carrierId = '';
    }
    public sssingin(data, index) {
        this.sssing = index;
        this.formData.freightPrice = data.priceValue;
        if (this.formData.pricingMode == 1) {
            this.formData.freightUnit = 1;
        } else {
            this.formData.freightUnit = 2;
        }
    }
    public SinglePriceList: any = [];
    async GetPrice() {
        this.SinglePriceList = [];
        if (!this.formData.carrierId) {
            return;
        }
        if (!this.formData.pricingMode) {
            return;
        }
        let data = {
            carrierId: this.formData.carrierId,
            priceListType: this.formData.pricingMode,
            deliveryProvince: this.detials.originProvinceStr,
            deliveryCity: this.detials.originCityStr,
            deliveryArea: this.detials.originCountyStr,
            arrivalProvince: this.detials.arrivalProvinceStr,
            arrivalCity: this.detials.arrivalCityStr,
            arrivalArea: this.detials.arrivalCountyStr,
            titleName: this.detials.carLength,
            weight: this.detials.planWeight,
        };
        let res = await yun.getSinglePriceList(data);
        this.SinglePriceList = res.priceListDetails[0].priceContent;
        this.sssing = '';
        this.formData.freightUnitPrice = '';
        // this.formData.freightUnitPrice = res.extData;
        console.log('this.SinglePriceList', this.SinglePriceList, res);
    }
    public carrierChange() {
        this.sscar = '';
        this.sssing = '';
        this.formData.freightUnit = '';
        this.formData.freightPrice = '';
        this.GetPrice();
    }
    selectCar1(data) {
        this.formData.carrierId = data.id;
        this.GetPrice();
    }
    carrierNamechange() {
        this.formData.carrierId = '';
    }
    async querySearch1(queryString, cb) {
        let res = await yun.GetCarrierList({ Name: this.formData.carrierName, count: -1 });
        console.log(res.data);
        let result = [];
        res.data.forEach((dd) => {
            let xx = {
                value: dd.name,
                id: dd.id,
            };
            result.push(xx);
        });
        cb(result);
    }
    handleInput(e, index) {
        e.target.value = e.target.value.match(/\d{1,9}(\.\d{0,4})?/) ? e.target.value.match(/\d{1,9}(\.\d{0,4})?/)[0] : '';
        this.formData.goodsList[index].planQuantity = e.target.value;
    }
    handleInput1(e, index) {
        e.target.value = e.target.value.match(/\d{1,9}(\.\d{0,2})?/) ? e.target.value.match(/\d{1,9}(\.\d{0,2})?/)[0] : '';
        this.formData[index] = e.target.value;
    }
    handleInput2(e, index) {
        e.target.value = e.target.value.match(/\d{1,9}(\.\d{0,2})?/) ? e.target.value.match(/\d{1,9}(\.\d{0,2})?/)[0] : '';
        this.formData.freightPrice = e.target.value;
    }
    public async carLengthChange(item) {
        //this.form.platformCompanyId = item.code
        // if (this.detials.inquiryCode || this.detials.clientOrderCode) {
        //     let resd = await yun.GetFreight({
        //         inquiryCode: this.detials.inquiryCode,
        //         batchNumber: this.detials.clientOrderCode,
        //         carLengthValue: this.formData.needCarLengthEnum
        //     })
        //     if (resd.price) {
        //         this.formData.freightAmount = resd.price ? resd.price: this.formData.freightAmount
        //         this.formData.freightPrice = resd.singlePrice ? resd.singlePrice: this.formData.freightPrice
        //         this.formData.needVehicleTypeEnum = resd.vehicleTypeValue ? resd.vehicleTypeValue: this.formData.needVehicleTypeEnum
        //     }
        // }
        this.carLengthList.forEach((data) => {
            if (data.value == item) this.formData.needCarLengthEnumStr = data.name;
        });
    }
    public carTypeChange(item) {
        //this.form.platformCompanyId = item.code
        console.log('item', item);
        this.vehicleTypeList.forEach((data) => {
            if (data.value == item) this.formData.needVehicleTypeEnumStr = data.name;
        });
    }
    public paginationOptions = {
        skip: 0,
        count: 10,
        currentPage: 1,
    };
    public total = 0;
    public pageSizes = [50];
    public lastPageNum = 0;
    public pageSize: number = 50;
    public firstPageBtnDisabled = true;
    public lastPageBtnDisabled = false;
    public handleCurrentChange(val) {
        console.log('onPaginationChange', val);
        this.firstPageBtnDisabled = val === 1 ? true : false;
        this.lastPageBtnDisabled = val === Math.ceil(this.total / this.paginationOptions.count) ? true : false;
        this.paginationOptions.currentPage = val;
        this.paginationOptions.skip = (this.paginationOptions.currentPage - 1) * this.paginationOptions.count;
        console.log('this.paginationOptions~', this.paginationOptions);
    }
    public handleSizeChange(val) {
        console.log('handleSizeChangeval' + JSON.stringify(val));

        this.paginationOptions.count = val;
        this.paginationOptions.currentPage = 1;
        this.handleCurrentChange(this.paginationOptions.currentPage);
        if (Math.ceil(this.total / val) < this.paginationOptions.currentPage) {
            this.paginationOptions.skip = 0;
        } else {
            this.paginationOptions.skip = (this.paginationOptions.currentPage - 1) * this.paginationOptions.count;
        }
    }
}
